module.exports = "/assets/data/f6907d625a4a7d7bfb3a2c397c49c567-GY1.data.json";